import createCrudApi from "@/app/services/baseApi";
const PecasApi = createCrudApi('pecas');

export default PecasApi;
